import React, { useEffect, useRef } from 'react';
import { AppContainer } from '../../UI/Container';
import AppFooter from '../../Footers/AppFooter';
import AvailableJobsHeader from './Sections/AvailableJobsHeader';
import { useResponsive } from '../../UI/ResponsiveContext';
import HorizontalJobs from './Sections/HorizontalJobs';
import OtherJobs from './Sections/OtherJobs';
import { connect, useDispatch, useSelector } from 'react-redux';
import { extractAvailableJobsUrlParams, generateLandingSearchUrl, getLocale } from '../../../utils/helperFunctions';
import { useLocation } from 'react-router-dom';
import { fetchAndSetAvailableJobs } from '../../../redux/Jobs/jobsActions';
import { Segment } from 'semantic-ui-react';
import { t } from 'i18next';
import { AppColumn } from '../../UI/Layouts';
import { SizedBox } from '../../UI/Sizes';
import useTheme from '../../../hooks/useTheme';
import AvailableWorkfields from './Sections/AvailableWorkfields';

const mapStateToProps = (state) => {
  return {
    jobs: state.jobs,
  };
};

const AvailableJobsPage = ({ jobs, fetchAndSetAvailableJobs }) => {
  const theme = useTheme();
  const { isMobile } = useResponsive();
  const dispatch = useDispatch();

  const coreState = useSelector((state) => state.core);
  const constants = coreState?.constants;

  const location = useLocation();

  const availableJobsPathData = extractAvailableJobsUrlParams(location.pathname);


  const searchButtonRef = new useRef(null);
  const availableJobsData = jobs?.availableJobs;


  const availableJobsWithHighestHourlyRate = availableJobsData?.availableJobsWithHighestHourlyRate ?? [];
  const otherAvailableJobs = availableJobsData?.otherAvailableJobs ?? [];

  const availableJobsLoading = availableJobsData?.availableJobsLoading ?? false;


  async function fetchAvailableJobs() {
    await fetchAndSetAvailableJobs(
      availableJobsPathData.roleOrLocation,
      availableJobsPathData.role,
      availableJobsPathData.location,
    )
  }

  useEffect(() => {
    if (!availableJobsData?.queryData) {
      fetchAvailableJobs();
    }
  }, [dispatch, availableJobsData?.queryData]);



  if (availableJobsLoading) {
    return (<Segment basic loading placeholder style={{
      height: "80vh",
      width: "100%",
    }} />)
  }



  return (<div>
    <AppContainer style={{
      width: '100vw',
      minHeight: isMobile ? '90vh' : '85vh',
    }}>
      <AvailableJobsHeader searchButtonRef={searchButtonRef} />
      <HorizontalJobs key={'hourly-jobs'}
        title={t('availablejobs.highest_hourly_rate.title')}
        description={t('availablejobs.highest_hourly_rate.description')}
        jobs={availableJobsWithHighestHourlyRate}
        linkUrl={`/${generateLandingSearchUrl({
          constants: constants,
          locations: availableJobsData.queryData?.location && [availableJobsData.queryData?.location.key],
          workroles: availableJobsData.queryData?.role && [availableJobsData.queryData?.role.roleId],
        })}`}
      />
      {Object.values(availableJobsData?.locationJobs ?? {})?.length > 0 && (
        <AppColumn>
          {Object.values(availableJobsData?.locationJobs).map((locationJobData, index) => (
            <HorizontalJobs key={`${locationJobData.locationData.id}-${index}`}
              title={t('jobs.location', {
                location: locationJobData.locationData.name,
              })}
              jobs={locationJobData.jobs}
              linkUrl={`/${generateLandingSearchUrl({
                constants: constants,
                locations: [locationJobData.locationData.key],
                workroles: availableJobsData.queryData?.role && [availableJobsData.queryData?.role.roleId],
              })}`}
            />
          ))}
        </AppColumn>
      )}
      {Object.values(availableJobsData?.roleJobs ?? {})?.length > 0 && (
        <AppColumn>
          {Object.values(availableJobsData?.roleJobs).map((roleJobsData, index) => (
            <HorizontalJobs key={`${roleJobsData.roleData.roleId}-${index}`}
              title={t('jobs.role', {
                role: roleJobsData.roleData.text[getLocale()].toLowerCase(),
              })}
              jobs={roleJobsData.jobs}
              linkUrl={`/${generateLandingSearchUrl({
                constants: constants,
                locations: availableJobsData.queryData?.location && [availableJobsData.queryData?.location.key],
                workroles: [roleJobsData.roleData.roleId],
              })}`}
            />
          ))}
        </AppColumn>
      )}
      <OtherJobs jobs={otherAvailableJobs} availableJobs={availableJobsData} />
      <AvailableWorkfields availableJobs={availableJobsData} />
    </AppContainer>
    {/* <StartSearchButton isVisible={isVisible} /> */}
    <SizedBox height={theme.spacing.contentPaddingBig} />
    <AppFooter forceShow />
  </div>);
}


export default connect(mapStateToProps, {
  fetchAndSetAvailableJobs,
})(AvailableJobsPage);
